import React, { useEffect, useState } from 'react';
import cec from './CatalogExplorerCategory.module.scss';
import CatalogExplorerItem from '@/widgets/CatalogExplorerItem/CatalogExplorerItem';
import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import { ECatalogCategoryViewType } from 'tkmp-lib/src/enums';

const CatalogExplorerCategory = observer(({ categories, isBrand = false, brandname }: any) => {
    const [categoriesItems, setCategoriesItems] = useState([]);

    useEffect(() => {
        const tmp = categories?.inner?.map((el: any) => ({
            ...el,
            isBrand: isBrand ?? false,
            brand_name: brandname ?? '',
        }));
        setCategoriesItems(tmp);
    }, [categories]);

    return (
        <Layout className={cec.container}>
            <Layout
                className={cec.catalogsGrid}
                style={{ display: 'flex', flexDirection: 'row', flexGrow: '0' }}
            >
                {categoriesItems?.map((el: unknown, i: number) => {
                    return (
                        <CatalogExplorerItem
                            key={i}
                            element={el}
                            type={ECatalogCategoryViewType.Row}
                        />
                    );
                })}
            </Layout>
        </Layout>
    );
});

export default CatalogExplorerCategory;
